(function() {
  require(["jquery", "underscore", "commons/maps/municipality", "bootstrap-collapse"], function($, _) {
    return $(function() {
      var compareYear, currentYear, mediaId;
      mediaId = $("#maps").data("mediaid");
      currentYear = $("#currentYear").val();
      if (currentYear == null) {
        currentYear = 2018;
      }
      compareYear = currentYear - 5;
      if (!mediaId) {
        return;
      }
      $.ajax({
        url: TSUrl.ApiUrl + "/Api/Map/MapSingleResult?mediaId=" + mediaId + "&regionSetId=0&fromYear=" + currentYear + "&ToYear=" + currentYear + "&dayType=0&regionType=3",
        dataType: "jsonp"
      }).done(function(res) {
        var map, values;
        if (!((res != null) && res.length)) {
          return;
        }
        $("#coverage-single-map").append(currentYear);
        values = {};
        _.each(res, function(item) {
          if (item.value != null) {
            return values[item.regionCode] = parseFloat(item.value.replace(",", "."));
          }
        });
        map = new jvm.WorldMap({
          container: $(".map-single"),
          map: "municipality",
          backgroundColor: "#28629C",
          zoomOnScroll: true,
          zoomMax: 20,
          series: {
            regions: [
              {
                attribute: "fill",
                scale: ["#FFFFFF", "#920000"],
                normalizeFunction: "polynominal",
                values: values
              }
            ]
          },
          regionStyle: {
            initial: {
              fill: "#FFFFFF",
              stroke: "#F2F2F2",
              "stroke-width": 0.2,
              "stroke-opacity": 1
            },
            hover: {
              fill: "#0F7D00"
            }
          },
          onRegionLabelShow: function(event, label, index) {
            if (values && values[index]) {
              return label.html([
                $("<div>", {
                  html: label.text(),
                  "class": "title"
                }), $("<div>", {
                  html: "Hushållstäckning: " + values[index] + "%",
                  "class": "value"
                })
              ]);
            } else {
              return label.html([
                $("<div>", {
                  html: label.text(),
                  "class": "title"
                })
              ]);
            }
          }
        });
        return map.setFocus(_.keys(values));
      });
      return $.ajax({
        url: TSUrl.ApiUrl + "/Api/Map/MapSingleResult?mediaId=" + mediaId + "&regionSetId=0&fromYear=" + compareYear + "&ToYear=" + currentYear + "&dayType=0&regionType=3",
        dataType: "jsonp"
      }).done(function(res) {
        var map, values;
        if (!((res != null) && res.length)) {
          return;
        }
        $("#coverage-range-map").append(compareYear + " - " + currentYear);
        values = {};
        _.each(res, function(item) {
          if (item.value != null) {
            return values[item.regionCode] = parseFloat(item.value.replace(",", "."));
          }
        });
        map = new jvm.WorldMap({
          container: $(".map-range"),
          map: "municipality",
          backgroundColor: "#28629C",
          zoomOnScroll: true,
          zoomMax: 20,
          series: {
            regions: (function() {
              var array, max, min, value;
              array = _.toArray(values);
              min = _.min(array);
              max = _.max(array);
              if (min < 0) {
                min = -min;
              }
              if (min < max) {
                value = max;
              } else {
                value = min;
              }
              return [
                {
                  attribute: "fill",
                  scale: ["#1325d5", "#FFFFFF", "#920000"],
                  normalizeFunction: "linear",
                  values: values,
                  min: -value,
                  max: value
                }
              ];
            })()
          },
          regionStyle: {
            initial: {
              fill: "#FFFFFF",
              stroke: "#F2F2F2",
              "stroke-width": 0.2,
              "stroke-opacity": 1
            },
            hover: {
              fill: "#0F7D00"
            }
          },
          onRegionLabelShow: function(event, label, index) {
            if (values && values[index]) {
              return label.html([
                $("<div>", {
                  html: label.text(),
                  "class": "title"
                }), $("<div>", {
                  html: "Hushållstäckning: " + values[index] + "%",
                  "class": "value"
                })
              ]);
            } else {
              return label.html([
                $("<div>", {
                  html: label.text(),
                  "class": "title"
                })
              ]);
            }
          }
        });
        return map.setFocus(_.keys(values));
      });
    });
  });

}).call(this);

//# sourceMappingURL=app.js.map
;
define("Apps/Coverage/script/app", function(){});

